import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import img1 from "../../assets/images/home-insurance/car-insurance.webp";
import img2 from "../../assets/images/home-insurance/bike-insurance.webp";
import img3 from "../../assets/images/home-insurance/health-insurance.webp";
import img4 from "../../assets/images/home-insurance/travel-insurance.webp";
import img5 from "../../assets/images/home-insurance/home-insurance.webp";

import "swiper/css";


function Insurance() {
  const data = [
    {
      id: 1,
      img: img1,
      icon: "flaticon-insurance-1",
      name: "Car Insurance",
      desc: "Stay protected on every drive with coverage for damage, theft, and accidents.",
    },
    {
      id: 2,
      img: img2,
      icon: "flaticon-insurance",
      name: "Bike Insurance",
      desc: "Ride with confidence knowing your bike is covered against loss and damage.",

    },
    {
      id: 3,
      img: img3,
      icon: "flaticon-health-insurance",
      name: "Health Insurance",
      desc: "Get medical coverage that keeps you and your family secure when it matters most.",
    },
    {
      id: 4,
      img: img4,
      icon: "flaticon-insurance-1",
      name: "Travel Insurance",
      desc: "Travel worry-free with protection for emergencies, delays, and lost baggage.",
    },
    {
      id: 5,
      img: img5,
      icon: "flaticon-insurance",
      name: "Home Insurance",
      desc: "Keep your home and belongings safe from fire, theft, and unforeseen events.",
    },
    {
      id: 6,
      img: img3,
      icon: "flaticon-health-insurance",
      name: "Health Insurance",
    },
    {
      id: 7,
      img: img1,
      icon: "flaticon-insurance-1",
      name: "Business Insurance",
    },
    {
      id: 8,
      img: img2,
      icon: "flaticon-insurance",
      name: "Life Insurance",
    },
    {
      id: 9,
      img: img3,
      icon: "flaticon-health-insurance",
      name: "Health Insurance",
    },
    {
      id: 10,
      img: img1,
      icon: "flaticon-insurance-1",
      name: "Life Insurance",
    },
  ];

  return (
    <>
      <div className="service-seven">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">Explore Our Insurance Categories</p>

            <h3 className="sec-title__title">
            Explore reliable coverage options made to fit every lifestyle.
            </h3>
          </div>

          <div className="row">
          {data.slice(0, 5).map((item, index) => (
            <div key={item.id} className="col-lg-4  col-md-5 col-sm-6 mb-4">
              <div
                className="service-card-five h-100 wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay={`${index * 150}ms`}
              >
                <div className="service-card-five__image">
                  <img src={item.img} alt={item.name} className="img-fluid" />
                </div>

                <div className="service-card-five__content">
                  <i className={`service-card-five__icon ${item.icon}`} />
                  <h3 className="service-card-five__title">
                    <Link to="/insurancesdetails">{item.name}</Link>
                  </h3>
                  <p className="service-card-five__text">{item.desc}</p>
                  {/* <Link
                    to="/insurancesdetails"
                    className="service-card-five__link"
                  >
                    <i className="far fa-arrow-right" />
                  </Link> */}
                </div>
              </div>
            </div>
          ))}
        </div>

          {/* <Swiper
  spaceBetween={30}
  slidesPerView={8} // show 8 slides at once
  breakpoints={{
    1200: { slidesPerView: 8 },
    992: { slidesPerView: 4 },
    768: { slidesPerView: 3 },
    576: { slidesPerView: 2 },
    0: { slidesPerView: 1 },
  }}
  >
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="service-card-five">
                  <div className="service-card-five__image">
                    <img src={item.img} alt={item.name} />
                  </div>

                  <div className="service-card-five__content">
                    <i className={`service-card-five__icon ${item.icon}`} />
                    <h3 className="service-card-five__title">
                      <Link to="/insurancesdetails">{item.name}</Link>
                   
                    </h3>

                    <p className="service-card-five__text">
                     hello world
                    </p>

                    <Link
                      to="/insurancesdetails"
                      className="service-card-five__link"
                    >
                      <i className="far fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}
        </div>
      </div>
    </>
  );
}

export default Insurance;
